export default function itemDetails() {
  const items = document.getElementsByClassName('user-submissions__error');

  if (items.length > 0) {
    items[0].scrollIntoView();
  }
}
